<!--框选题号-->
<template>
	<div class="drop-position" ref="config" :style="concludeWH">
		<vue-drag-resize
			class="mark-out-position"
			:class="canDrawRect ? 'pointer-none' : 'pointer-active'"
			v-for="(rectItem, rectIndex) in rectDetail"
			:key="rectItem.pkId"
			:x="rectItem.areaMinX"
			:y="rectItem.areaMinY"
			:w="operateWidth(rectItem)"
			:h="operateHeight(rectItem)"
			:isActive="rectIndex === tempActiveArea"
			:isDraggable="rectIndex === tempActiveArea"
			:isResizable="rectIndex === tempActiveArea"
			@click.native="exitDrag"
			@dragstop="rectDragResize($event, rectIndex)"
			@resizestop="rectDragResize($event, rectIndex)"
		>
			<template>
				<div class="rect-title-wrap">
					<span class="rect-num title-rect-num" v-show="JSON.parse(rectItem.remarks).version">
						{{ `（${num + rectIndex + 1}/${tempRectTitle.length}）` }}
					</span>
					<i v-show="JSON.parse(rectItem.remarks).version" class="iconfont iconlajitong1 del-icon" @click="dropArea({ val: rectItem, state: true })">
					</i>
					<div v-show="JSON.parse(rectItem.remarks).version" class="drop-menu">
						<el-dropdown class="el-dropdown-link" @command="dropDownMenu($event, { val: rectItem, curIndex: rectIndex })">
							<i class="iconfont iconjiantou-down "></i>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="drag">拖拽选区</el-dropdown-item>
								<el-dropdown-item command="del">删除选区</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</template>
		</vue-drag-resize>
	</div>
</template>

<script>
import VueDragResize from 'vue-drag-resize'
import isDragResize from '@/views/template-configuration/utils/mixin/is-drag-resize'
import drawRect from '@/views/template-configuration/utils/mixin/draw-rect'
import fixWH from '@/views/template-configuration/utils/mixin/fix-wh'
import fixRect from '@/views/template-configuration/utils/mixin/fix-rect'
import { mapGetters } from 'vuex'
export default {
	name: 'temp-title',
	mixins: [isDragResize, fixWH, fixRect, drawRect],
	components: {
		VueDragResize
	},
	data() {
		return {
			rectDetail: [],
			allRectDetail: [],
			query: this.$route.query,
			emitType: 'choose',
			num: 0
		}
	},
	computed: { ...mapGetters('examination/configation', ['tempRectTitle']) },
	watch: {
		tempRectTitle: {
			handler(val) {
				this.rectDetail = []
				this.initCurRect(val, this.tempCurrentImgIndex.curIndex)
			},
			immediate: true,
			deep: true
		},
		tempCurrentImgIndex(val) {
			this.rectDetail = []
			this.initCurRect(this.tempRectTitle, val.curIndex)
		}
	},
	mounted() {
		const _this = this
		window.addEventListener('keydown', function(event) {
			if (event.keyCode === 17) {
				_this.isPermitDo = true
			}
		})
		window.addEventListener('keyup', function() {
			if (event.keyCode === 17) {
				_this.isPermitDo = false
			}
		})
	},
	methods: {
		//初始化当前的框框
		initCurRect(rectDetail, curIndex) {
			if (rectDetail.length === 0) return false
			this.num = 0
			rectDetail.map(res => {
				if (curIndex + 1 > Number(JSON.parse(res.remarks).page)) {
					this.num += 1
				}
				if (res.remarks && curIndex + 1 === Number(JSON.parse(res.remarks).page)) {
					this.rectDetail.push(res)
				}
			})
		}
	}
}
</script>

<style scoped lang="less">
@import '../utils/css/mark-point.less';
</style>
